import { NextPageWithLayout } from 'next';
import ForgotPassword from '@modules/auth/ForgotPassword';

const ForgotPasswordPage: NextPageWithLayout = () => <ForgotPassword />;

ForgotPasswordPage.getLayoutProps = () => ({ hideFooter: true });

export default ForgotPasswordPage;
